module.exports = __webpack_public_path__ + "img/icon-ygq.d2cf14eb.png";